module.exports = __webpack_public_path__ + "static/media/ic-arrow-left.c49ca2c0.svg";